// extracted by mini-css-extract-plugin
export default {"screen":"Audio_screen__VZys7","logo":"Audio_logo__bougW","body":"Audio_body__hWfac","headerBox":"Audio_headerBox__TxZs1"};